import fetchAPI from "./fetchAPI"

export async function F2FLogin(pin, memberId, entryCode, captcha) {
  const { F2FLogin } = await fetchAPI(
    `query($pin: String!, $memberId: String!, $entryCode: String!, $captcha: String!) {
      F2FLogin(pin: $pin, memberId: $memberId, entryCode: $entryCode, captcha: $captcha) {
            isValid,
            sessionId
          }
        }`,
    {
      variables: {
        pin,
        memberId,
        entryCode,
        captcha
      }
    }
  )

  return F2FLogin
}

export async function F2FLogout(sessionId) {
  const { F2FLogout } = await fetchAPI(
    `query($sessionId: String!) {
      F2FLogout(sessionId: $sessionId) {
          isLoggedOut,
          }
        }`,
    {
      variables: {
        sessionId
      }
    }
  )

  return F2FLogout?.isLoggedOut
}
